import WithContactUsAttributes from "./WithContactUsAttributes";

const WithContactSupportAttributes = (additionalAttributes) => {
  return WithContactUsAttributes({
    'data-bs-type': 'support',
    'data-bs-title': 'Support',
    ...additionalAttributes,
  });
};

export default WithContactSupportAttributes;